import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default function (params) {
  const { data, exec, isLoading, isRequestSuccessed } = useRequest({
    url: '',
    name: 'materialCategoryPageGet',
  });
  useEffect(() => {
    if (params && JSON.stringify(params) !== '{}') {
      let url = `/api/material_types`;
      Object.keys(params).forEach((key, index) => {
        if (index === 0) {
          url += '?'
        } else {
          url += '&'
        };
        url += `${key}=${params[key]}`;
      });
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);
  return [data || {}, isLoading, isRequestSuccessed];
}